export enum ScrollAreaRootCssVars {
  /**
   * The scroll area's corner height.
   * @type {number}
   */
  scrollAreaCornerHeight = '--scroll-area-corner-height',
  /**
   * The scroll area's corner width.
   * @type {number}
   */
  scrollAreaCornerWidth = '--scroll-area-corner-width',
}
